var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-basic',{attrs:{"caption":"詳細","description":_vm.$store.state.habit.description,"action":_vm.action}})}
var staticRenderFns = []

export { render, staticRenderFns }